import { render, staticRenderFns } from "./CompareKpiHeader.vue?vue&type=template&id=64a398d2&scoped=true&"
import script from "./CompareKpiHeader.vue?vue&type=script&lang=js&"
export * from "./CompareKpiHeader.vue?vue&type=script&lang=js&"
import style0 from "./CompareKpiHeader.vue?vue&type=style&index=0&id=64a398d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a398d2",
  null
  
)

export default component.exports